import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormNumber from "../Form/FormNumber";

class NoteFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            formUrl,
            isEdit,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="ref_type" value={values.ref_type} onChange={handleChange}/>
                <input type="hidden" name="ref_id" value={values.ref_id} onChange={handleChange}/>
                <input type="hidden" name="user_id" value={values.user_id} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid container item xs={12} spacing={16}>
                        <Grid item xs={12}>
                            <FormField
                                type="text"
                                name="note"
                                label={i18n.get('default.note')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.note}
                                multiline
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/persons/${values.id}`}
                                confirmMessage={i18n.get('persons.confirm_message')}
                                successMessage={i18n.get('persons.delete_success_message')}
                                handleSuccess={() => {
                                    history.go(-1)
                                }}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default NoteFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Notes/NoteFormFields.js